/* AUTAVEX — «Вам може сподобатись»: картки розділів */
window.AV_ALSO={
 eva:{t:'EVA \u043a\u0438\u043b\u0438\u043c\u043a\u0438',s:'\u0432\u0456\u0434 1 650 \u20b4',u:'/pages/eva-kylymky',
   p:'72D2D156-7776-4773-92A0-29DA6A28F1CB.jpg?v=1786530126'},
 vors:{t:'\u0412\u043e\u0440\u0441\u043e\u0432\u0456 \u043a\u0438\u043b\u0438\u043c\u043a\u0438',s:'\u0432\u0456\u0434 1 850 \u20b4',u:'/pages/vorsovi-kylymky',
   p:'FullSizeRender_2b48f066-9d75-4876-ac2d-4f75848294fd.jpg?v=1786443245'},
 eko:{t:'\u041a\u0438\u043b\u0438\u043c\u043a\u0438 \u0437 \u0435\u043a\u043e\u0448\u043a\u0456\u0440\u0438',s:'\u0432\u0456\u0434 1 750 \u20b4',u:'/pages/kylymky-ekoshkira',
   p:'4C37884E-AF99-48AD-A5B6-E2366DFE6516.jpg?v=1786471792'},
 org:{t:'\u041e\u0440\u0433\u0430\u043d\u0430\u0439\u0437\u0435\u0440\u0438',s:'\u0432\u0456\u0434 1 699 \u20b4',u:'/pages/organaizery',
   p:'3D6DE194-1571-4FAC-AC79-817853D230DB.jpg?v=1786363035'},
 pil:{t:'\u0410\u0432\u0442\u043e\u043c\u043e\u0431\u0456\u043b\u044c\u043d\u0456 \u043f\u043e\u0434\u0443\u0448\u043a\u0438',s:'\u0432\u0456\u0434 750 \u20b4',u:'/pages/podushky',
   p:'D0F4A757-B403-4800-9B98-808E72214601.jpg?v=1786267401'},
 nak:{t:'\u041d\u0430\u043a\u0438\u0434\u043a\u0438 \u043d\u0430 \u0441\u0438\u0434\u0456\u043d\u043d\u044f',s:'\u0432\u0456\u0434 1 850 \u20b4',u:'/pages/nakydky-na-sydinnya',
   p:'IMG-3944.jpg?v=1786524644'}
};
window.AV_ALSO_MAP={
 'eva-kylymky':['org','pil','nak'],
 'vorsovi-kylymky':['eva','org','pil'],
 'kylymky-ekoshkira':['org','nak','pil'],
 'organaizery':['eva','eko','pil'],
 'podushky':['nak','org','eva'],
 'nakydky':['pil','org','eko'],
 /* у кошику — усі шість розділів */
 '/cart':['eva','vors','eko','org','pil','nak']
};
